// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","light":"Footer_light__88mrK","left":"Footer_left__+35ST","links":"Footer_links__q2x7d"};